import React, { useContext } from "react";
import { MsTeamsContext } from "msTeams/store";
import { RegularText } from "shared/components";
import { CallIcon } from "@fluentui/react-northstar";
import { ButtonCard } from "../buttonCard/ButtonCard";

export interface PhoneNumberProps {
    text?: string | undefined;
    number: string;
}

const openPhoneDialogOnMobile = (phoneNumber: string | undefined) => {
    window.open(`tel:${phoneNumber}`, "_self");
};

export const PhoneNumber: React.FC<PhoneNumberProps> = (props) => {
    const msTeamsContext = useContext(MsTeamsContext);

    if (msTeamsContext.isMobileClient) {
        return (
            <ButtonCard
                textLine1={props.text}
                textLine2={props.number}
                onClick={() => {
                    openPhoneDialogOnMobile(props.number);
                }}
                icon={
                    <CallIcon
                        styles={({ theme: { siteVariables } }) => ({
                            color: siteVariables.colorScheme.brand.foreground2,
                        })}
                        outline
                    />
                }
            />
        );
    }
    return <RegularText content={props.number}></RegularText>;
};
